import { BaseItem, MenuItemType } from '../../../../components/PaginatedTable/PaginatedTable.types';
import { ISqlQueryObj } from '../../types';

export const getDataSourceMenuItems = (
  handleEditClick: (row: ISqlQueryObj) => void,
): MenuItemType<BaseItem>[] => [
  {
    title: 'Edit',
    onClick: (_id, row) => {
      handleEditClick(row?.original as unknown as ISqlQueryObj);
    },
  },
];
